import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PagesComponent } from './pages/pages.component';
import { AppSettings } from './app.settings';
import { SharedModule } from './shared/shared.module';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { SpinnerComponent } from './shared/spinner/spinner.component';
import { OverlayContainer, Overlay } from '@angular/cdk/overlay';
// import { CustomOverlayContainer } from './theme/utils/custom-overlay-container';
// import { NotFoundComponent } from './pages/not-found/not-found.component';

import { TokenInterceptor } from './theme/utils/token.interceptor';
import { LoaderInterceptor } from './theme/utils/loader.interceptor';
import { ErrorHandlerInterceptor } from './theme/utils/error-handler.interceptor';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SidenavMenuComponent } from './shared/sidenav-menu/sidenav-menu.component';


@NgModule({
  declarations: [
    AppComponent,
    PagesComponent,
    SpinnerComponent,
    // NotFoundComponent,
    SidenavMenuComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedModule,
    HttpClientModule,
   
  ],
  providers: [
    AppSettings,
    // { provide: OverlayContainer, useClass: CustomOverlayContainer },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorHandlerInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
